import { WebinarSession, WebinarType } from './components'

export const inferAccessibleTypesFromSessions = (
  sessions: WebinarSession[],
  allWebinarTypes: WebinarType[]
): string[] => {
  const accessibleTypes = new Set<string>()

  sessions.forEach((session) => {
    const matchingType = allWebinarTypes.find((type) => type.webinarId === session.webinarId)
    if (matchingType) {
      accessibleTypes.add(matchingType.nickname)
    }
  })

  return Array.from(accessibleTypes)
}

export const isRegisteredForMastermind = (
  categoryName: string,
  sessions: WebinarSession[],
  allWebinarTypes: WebinarType[]
): boolean => {
  const webinarType = allWebinarTypes.find((type) => type.nickname === categoryName)

  if (!webinarType) {
    return false
  }

  const matchingSessions = sessions.filter(
    (session) => session.webinarId === webinarType.webinarId || session.webinarId === webinarType.id
  )

  const hasRegisteredSessions = matchingSessions.some(
    (session) => session.join_url || session.is_registered
  )

  return hasRegisteredSessions
}

export const isCategoryAccessible = (
  category: string,
  accessibleWebinarTypes: string[],
  sessions: WebinarSession[] = [],
  allWebinarTypes: WebinarType[] = []
): boolean => {
  if (category.includes('Mastermind')) {
    return isRegisteredForMastermind(category, sessions, allWebinarTypes)
  }

  return accessibleWebinarTypes.includes(category)
}

export const getFilteredSessions = (
  sessions: WebinarSession[],
  selectedCategory: string | null,
  allWebinarTypes: WebinarType[]
): WebinarSession[] => {
  if (!selectedCategory) {
    return sessions
  }

  const selectedType = allWebinarTypes.find((type) => type.nickname === selectedCategory)

  if (!selectedType) {
    return []
  }

  const targetWebinarId = selectedType.webinarId || selectedType.id

  if (!targetWebinarId) {
    return []
  }

  return sessions.filter((session) => session.webinarId === targetWebinarId)
}
